var lib_core = require("lib-core");
var cio_datamodel = require("cio-datamodel");
var IpcSmdPadGeneratorInteractionModel = require('./ipcSmdPadGeneratorInteractionModel.js');
var PackageGeneratorInspectorConfig = require("../packageGeneratorInspectorConfig.js");

var DualRowPackageWithDifferentPadGeneratorInteractionModel = function(parametricData, userSettingsModel, showFootprintParams, withCustomFootprintParams) {
    IpcSmdPadGeneratorInteractionModel.call(this, parametricData, userSettingsModel, showFootprintParams, withCustomFootprintParams);
};

lib_core.inherit(DualRowPackageWithDifferentPadGeneratorInteractionModel, IpcSmdPadGeneratorInteractionModel);
DualRowPackageWithDifferentPadGeneratorInteractionModel.$class = 'DualRowPackageWithDifferentPadGeneratorInteractionModel';

module.exports = DualRowPackageWithDifferentPadGeneratorInteractionModel;

DualRowPackageWithDifferentPadGeneratorInteractionModel.prototype.initialize = function() {
	var self = this;

	IpcSmdPadGeneratorInteractionModel.prototype.initialize.call(this);

	this.oddPadHeightMin = this.shadow("oddPadHeightMin",
        function() {
            return self.data.oddPadHeightMin() / self.getUnitFactor();
        },
        function(value) {
            return self.data.oddPadHeightMin(parseFloat(value) * self.getUnitFactor());
        }, [
            self.data.oddPadHeightMin, this.userSettingsModel.distanceUnit
        ]
    );

    this.oddPadHeightMax = this.shadow("oddPadHeightMax",
        function() {
            return self.data.oddPadHeightMax() / self.getUnitFactor();
        },
        function(value) {
            return self.data.oddPadHeightMax(parseFloat(value) * self.getUnitFactor());
        }, [
            self.data.oddPadHeightMax, this.userSettingsModel.distanceUnit
        ]
    );
};

DualRowPackageWithDifferentPadGeneratorInteractionModel.prototype.getInspectorElementForTerminalWidth = function() {
    var normalTerminalWidth = PackageGeneratorInspectorConfig.getMinMaxRow('b', this.LCLZ('terminalWidth', 'Terminal Width'), false, this.padHeightMin, false, this.padHeightMax, this.userSettingsModel.distanceUnit);
    var oddTerminalWidth = PackageGeneratorInspectorConfig.getMinMaxRow('b1', this.LCLZ('oddTerminalWidth', 'Odd Terminal Width'), false, this.oddPadHeightMin, false, this.oddPadHeightMax, this.userSettingsModel.distanceUnit);

    return [normalTerminalWidth, oddTerminalWidth];
};